import getConfig from 'next/config';

export const {
  CLUSTER,
  ENV,
  site_captcha_key,
  sentry_dsn: sentryDsn,
} = getConfig().publicRuntimeConfig;
